import type { PrayerDay, PrayerRequest } from '../../shared/api/types';
import { formatWhen } from '../events/shared';

export const dayTitle = (d: Pick<PrayerDay, 'title'>) => d.title || 'Jornada de oración';

/** Texto para WhatsApp con las peticiones seleccionadas. */
export function whatsappText(requests: PrayerRequest[], heading: string, day?: PrayerDay): string {
  const lines = [`*${heading}*`];
  if (day) {
    lines.push(`_${formatWhen(day.startsAt, day.endsAt)}_`);
    if (day.mode === 'virtual' && day.meetingUrl) lines.push(`En línea: ${day.meetingUrl}`);
    else if (day.placeName) lines.push(`Lugar: ${day.placeName}${day.address ? `, ${day.address}` : ''}`);
    if (day.leader) lines.push(`Dirige: ${day.leader.name}`);
  }
  lines.push('');
  requests.forEach((r, i) => lines.push(`${i + 1}. ${r.body}${r.author ? ` — ${r.author.name}` : ''}`));
  const text = lines.join('\n');
  return text.length > 3500 ? `${text.slice(0, 3490)}…` : text;
}

export const whatsappUrl = (text: string) => `https://wa.me/?text=${encodeURIComponent(text)}`;

export const printUrl = (q: { jornada?: string; ids?: string[] }) =>
  q.jornada ? `/app/oracion/imprimir?jornada=${q.jornada}` : `/app/oracion/imprimir?ids=${(q.ids ?? []).join(',')}`;
